import { render, staticRenderFns } from "./SearchTargetPage.vue?vue&type=template&id=aa2b2b02&scoped=true&"
import script from "./SearchTargetPage.vue?vue&type=script&lang=js&"
export * from "./SearchTargetPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchTargetPage.vue?vue&type=style&index=0&id=aa2b2b02&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2b2b02",
  null
  
)

export default component.exports